//
//
//
//
//
//

import index from './index';
export default {
  name: 'IMResponsible',
  components: {
    index: index
  }
};